import React from "react";
import styled from "styled-components";

import useDoubleClick from "../../hooks/useDoubleClick/useDoubleClick";

import { stopEventPropagation } from "./helpers";

const DoubleTapStyled = styled.div`
  border-radius: 100%;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  width: 50%;
  z-index: 1;

  & + & {
    left: auto;
    right: 0;
    transform: translateX(50%);
  }

  /* stylelint-disable-next-line no-descending-specificity */

  &,
  &:focus {
    outline: none !important;
  }
`;

const DoubleTap = ({ onDoubleTap, onSingleTap }) => (
  <DoubleTapStyled
    onClick={useDoubleClick({
      doubleClickDelay: 400,
      onClick: onSingleTap,
      onDoubleClick: onDoubleTap
    })}
    onFocus={stopEventPropagation}
    onMouseMove={stopEventPropagation}
    onMouseOut={stopEventPropagation}
    tabIndex={-1}
  />
);

export const DoubleTaps = ({
  onSeekFor,
  showActionIcon,
  toggleControls
}: {
  onSeekFor: (amount: number) => void;
  showActionIcon: (icon: string) => void;
  toggleControls: (showControls?: boolean) => void;
}) => (
  <>
    <DoubleTap
      onDoubleTap={() => {
        onSeekFor(-10);
        showActionIcon("back");
        toggleControls(false);
      }}
      onSingleTap={toggleControls}
    />
    <DoubleTap
      onDoubleTap={() => {
        onSeekFor(10);
        showActionIcon("forward");
        toggleControls(false);
      }}
      onSingleTap={toggleControls}
    />
  </>
);
